import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAuth } from '@spotify/confidence-core-react';
import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

function LoginPageComponent() {
  const [searchParams] = useSearchParams();
  const { loginWithRedirect } = useAuth();
  const organization = searchParams.get('organization');

  useEffect(() => {
    loginWithRedirect({
      authorizationParams: {
        organization: organization || undefined,
      },
    });
  }, [organization, loginWithRedirect]);

  return null; // This page will redirect immediately
}

export const LoginPage = withPageImpression(LoginPageComponent, {
  pageId: 'login',
});
